module.exports = __webpack_public_path__ + "static/media/squareBlack.d7f68e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/squareBlack.png
// module id = 104
// module chunks = 0